export default [
  {
    path: '/currencies',
    name: 'dashboard-currencies',
    component: () => import('@/views/dashboard/currencies/Currencies.vue'),
  },
]
